import foldyDefaultSiteMap from "./foldyDefaultSiteMap";
export default {
  routes: [
    {
      path: "/whatsNew",
      title: "Demo",
      icon: "fas fa-sparkles",
      children: [
        {
          path: "/sandbox",
          title: "What's New?",
        },
      ]
    },
    ...foldyDefaultSiteMap.routes
  ]
}
